<template>
  <div id="sidebar" :class="{ 'sidebar-open': isOpen, 'expanded': isExpanded }" @mouseover="showFullSidebar" @mouseleave="hideFullSidebar" class="bg-light">
    <div class="header-logo">
      <!-- Header logo content -->
    </div>
    <ul>
      <li v-for="(item, index) in navItems" :key="index" @click="selectItem(index)" :class="{ 'selected': selectedIndex === index }">
        <div class="icon-container">
          <i :class="item.icon" style="background-color: #E95913; border-radius: 100%; padding: 13px; color: white;"></i>
        </div>
        <span class="fw-bolder fs-16px mb-2 title" :class="{ 'visible': isTitleVisible }">{{ item.name }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      isOpen: false,
      isExpanded: false,
      isTitleVisible: false, 
      selectedIndex: null
    };
  },
  methods: {
    selectItem(index) {
      this.selectedIndex = index;
      this.$router.push(this.navItems[index].url);
    },
    showFullSidebar() {
      this.isOpen = true;
      this.isExpanded = true;
      this.emitResizeEvent();
    },
    hideFullSidebar() {
      this.isOpen = false;
      this.isExpanded = false;
      this.emitResizeEvent();
    },
    emitResizeEvent() {
      this.$emit('sidebar-resize', this.getSidebarWidth());
    },
    handleTransitionEnd() {
      this.isTitleVisible = this.isExpanded;
    },
    getSidebarWidth() {
      return this.isExpanded ? 300 : 120;
    }
  },
  mounted() {
    this.$el.addEventListener('transitionend', this.handleTransitionEnd);
    this.emitResizeEvent(); 
  },
  beforeDestroy() {
    this.$el.removeEventListener('transitionend', this.handleTransitionEnd);
  }
};
</script>
<style scoped>
#sidebar {
  width: 110px;
  transition: width 0.3s;
  position: fixed;
  top: 90px;
  height: calc(100vh - 60px); 
  overflow-y: auto;
}

#sidebar.sidebar-open {
  width: 300px;
}

.title {
  display: none;
}

#sidebar.expanded .title.visible {
  display: inline;
}

.icon-container {
  display: inline;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin: 20px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  z-index: 1;
  border-radius: 35px;
}

li::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background-color: #E95913;
  transition: left 0.3s ease; 
  border-radius: 35px;
  z-index: -1;
}

li:hover::before {
  left: 0; 
}

li:hover {
  color: white;
}


li.selected {
  background-color: #E95913;
  color: white;
  border-radius: 35px;
}
.fw-bolder .fs-16px .mb-2.title.selected{
color:white
}
.fw-bolder .fs-16px .mb-2.title:hover{
  color: white;
}
.sidebar-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-bottom: 4px dashed;
  border-bottom: 4px solid\9;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}

.dropdown-menu {
  display: none;
  position: absolute;
  z-index: 1000;
  padding: 5px 0;
  bottom: 100%;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
}

.dropdown-menu>li>a {
  display: block;
  padding: 8px 12px;
  color: #333;
  text-decoration: none;
}

.dropdown-menu>li>a:hover {
  background-color: #f5f5f5;
}

.open>.dropdown-menu {
  display: block;
}

.fw-bolder .fs-16px .mb-2.title {
  color: #2d353c;
}
</style>



// WEBPACK FOOTER //
// src/admin/components/Sidebar/Sidebar.vue